import React from 'react'

export const WrapperLoadinModal = ({ error = false, loading = false, children }) => {
    if (error) {
        return (
            <div className='min-h-[400px] 2xl:min-h-[600px] flex flex-col gap-2 items-center justify-center'>
                <p className='text-[16px] text-[#CDCDCD] font-semibold'>Error al obtener datos</p>
            </div>
        )
    }

    if (loading) {
        return (
            <>
                <div className='min-h-[400px] 2xl:min-h-[600px] flex flex-col gap-2 items-center justify-center'>
                    <div className='h-[80px] w-[80px]'>
                        <svg width="100%" height="100%" viewBox="0 0 54 68" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.6663 60.668H40.333V50.668C40.333 47.0013 39.0275 43.8624 36.4163 41.2513C33.8052 38.6402 30.6663 37.3346 26.9997 37.3346C23.333 37.3346 20.1941 38.6402 17.583 41.2513C14.9719 43.8624 13.6663 47.0013 13.6663 50.668V60.668ZM26.9997 30.668C30.6663 30.668 33.8052 29.3624 36.4163 26.7513C39.0275 24.1402 40.333 21.0013 40.333 17.3346V7.33463H13.6663V17.3346C13.6663 21.0013 14.9719 24.1402 17.583 26.7513C20.1941 29.3624 23.333 30.668 26.9997 30.668ZM0.333008 67.3346V60.668H6.99967V50.668C6.99967 47.2791 7.79134 44.0985 9.37467 41.1263C10.958 38.1541 13.1663 35.7791 15.9997 34.0013C13.1663 32.2235 10.958 29.8485 9.37467 26.8763C7.79134 23.9041 6.99967 20.7235 6.99967 17.3346V7.33463H0.333008V0.667969H53.6663V7.33463H46.9997V17.3346C46.9997 20.7235 46.208 23.9041 44.6247 26.8763C43.0413 29.8485 40.833 32.2235 37.9997 34.0013C40.833 35.7791 43.0413 38.1541 44.6247 41.1263C46.208 44.0985 46.9997 47.2791 46.9997 50.668V60.668H53.6663V67.3346H0.333008Z" fill="#CDCDCD" />
                        </svg>
                    </div>
                    <p className='text-[16px] text-[#CDCDCD] font-semibold'>Actualizando información...</p>
                </div>
            </>
        )
    }
    return children
}
